import { render, staticRenderFns } from "./DealerTutorialView.vue?vue&type=template&id=7b1ddf8c&"
import script from "./DealerTutorialView.vue?vue&type=script&lang=js&"
export * from "./DealerTutorialView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports